import { JSX } from 'react';
import { merge } from '../../helpers/classes';
export function Prose({
  content,
  className = '',
  ...rest
}: {
  content: string;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      {...rest}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
      className={merge(
        '[&_a]:text-primary-600 relative text-gray-800 [&_a]:no-underline [&_h3]:my-3 [&_h4]:my-0 [&_h4]:mr-1 [&_p]:mb-4',
        className,
      )}
    />
  );
}
